import React, { useEffect, useState, useRef } from 'react';
import Scheme_Allot_Afso from './Scheme_Allot_Afso';
import tableToExcel from '../../excel-downloads/tableToExcel';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const handleDownload = () => {
    tableToExcel('DistrictReport', 'My Worksheet');
};

const AllotDist_data = async (params) => {

    const response = await fetch(`${process.env.REACT_APP_URL_ALLOTMENT}/SchemeAllotment/getScheme_Allot_Dist`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const SchemeAllotDist = ({ month, year,scheme_id , type , heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
    const [totals, setTotals] = useState([]); // State for storing column totals
    const detailsRRef = useRef(null);
 
    const handleDistClick = (month, year,scheme_id , type, dist_code, heading) => {
        setRenderContentt(null);
        setTimeout(() => {
            setRenderContentt(
                <Scheme_Allot_Afso month={month} year={year} scheme_id={scheme_id}
                type = {type} dist_code={dist_code} heading={heading} />
            );
        }, 10);
    };

    const calculateTotals = (data) => {

        const columnCount = data[0].c_lst.length;
        const columnTotals = new Array(columnCount).fill(0);  
    
        data.forEach(item => {
            item.c_lst.forEach((colItem, colIndex) => {
                columnTotals[colIndex] += parseFloat(colItem.qty_1) || 0; 
            });
        });
    
        setTotals(columnTotals); 
    };
    
    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await AllotDist_data({ month, year,scheme_id , type, heading });
                setTabHeading(response_data.heading);  
                if ( response_data.data.length > 0) {
                    setReportData(response_data.data);
                    calculateTotals(response_data.data); 
                } else {
                    setReportData("No data found");
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [month, year,scheme_id , type, heading]);
      
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [loading, error, reportData]);

    if (loading) {
        
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }
     if (error) {
        console.error(error);
        return <div className="mainhead" align="center">Internal Error</div>;
    }
    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }
     
        if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
    return <div className="mainhead" align="center">
        No data found
    </div>
}




const S_totals = reportData.reduce(
    (acc, item) => {
       acc.total_cards += item.total_cards || 0;
      acc.total_units += item.total_units || 0;
      return acc;
    },
    {
       total_cards: 0,
      total_units: 0,
    }
  );


    return (
        <> 

            <table align="center" width="80%" border={1} id="DistrictReport">
                <thead>
                    <tr className="tableheader">
                        <th colSpan={4 + reportData[0].c_lst.length  }>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>District</th>
                        <th rowSpan={2}>Total Cards</th>
                        <th rowSpan={2}>Total Unit</th> 
                            <th colSpan={reportData[0].c_lst.length} >
                            Commodity
                            </th>
                        
                    </tr>
                    <tr className="tableheader">
                        {reportData[0].c_lst.map((item, index) => (
                            <th key={index}>{item.comm_name_en}<br />({item.unit_type||'Kg'})</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.dist_code}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>
                                <a
                                    style={{ cursor: 'pointer', color: 'blue' }}
                                    onClick={() => handleDistClick(month, year,scheme_id , type, item.dist_code, tabHeading)}
                                >
                                    {item.dist_name_en}
                                </a>
                            </td>
                            <td style={{ textAlign: 'right' }}>{item.total_cards}</td>
                            <td style={{ textAlign: 'right' }}>{item.total_units}</td>
                            {item.c_lst.map((item1, index) => (
                                <td style={{ textAlign: 'right' }} key={index}>{item1.qty_1}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr className="tableheader">
                        <td colSpan={2}>Total</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{S_totals.total_cards}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{S_totals.total_units}</td>
                        {totals.map((total, index) => (
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }} key={index}>{total.toFixed(3)}</td>
                        ))}
                    </tr>
                </tfoot>
            </table>
            <br /><br />
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};

export default SchemeAllotDist;
